import { env } from "~/env";
import { fetchBlob } from "~/shared/api/client";
import { buildRequestHeaders } from "~/shared/api/client-helpers";
import type { RequestContext } from "~/shared/api/client-types";
import { getValidAccessToken } from "~/shared/lib/auth/auth-client";

/**
 * Скачивает бинарный ответ API как файл. `context` (напр. `{ workspaceId }`) добавляет
 * заголовок `X-Workspace-Id` — нужен для workspace-scoped выгрузок; без него ставится
 * только `Authorization` (глобальные admin-эндпоинты).
 */
export async function downloadFromApi(
    path: string,
    filename: string,
    context?: RequestContext,
): Promise<void> {
    const token = await getValidAccessToken();
    if (!token) throw new Error("Not authenticated");

    const baseUrl = env.VITE_API_URL;
    const { blob, headers } = await fetchBlob(`${baseUrl}${path}`, {
        headers: buildRequestHeaders(token, context),
    });

    const contentDisposition = headers.get("content-disposition");
    const serverFilename = contentDisposition?.match(/filename="?([^";\n]+)"?/)?.[1];

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = serverFilename ?? filename;
    a.click();
    URL.revokeObjectURL(url);
}
